var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTransaction(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 13.0918H18.5C18.8978 13.0918 19.2794 12.9338 19.5607 12.6525C19.842 12.3712 20 11.9896 20 11.5918C20 11.194 19.842 10.8124 19.5607 10.5311C19.2794 10.2498 18.8978 10.0918 18.5 10.0918H17.5C17.1022 10.0918 16.7206 9.93376 16.4393 9.65246C16.158 9.37115 16 8.98962 16 8.5918C16 8.19397 16.158 7.81244 16.4393 7.53114C16.7206 7.24983 17.1022 7.0918 17.5 7.0918H20",
    stroke: "#F2F2F2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 3.0918H5C4.73478 3.0918 4.48043 3.19715 4.29289 3.38469C4.10536 3.57223 4 3.82658 4 4.0918V21.0918L6.34 20.0918L8.67 21.0918L11 20.0918L13.33 21.0918L15.66 20.0918L18 21.0918V18.0918",
    stroke: "#F2F2F2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 7.0918V6.0918M18 14.0918V13.0918M12 15.0918H8M12 11.0918H8",
    stroke: "#F2F2F2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTransaction);
export default __webpack_public_path__ + "static/media/icon_transaction.48fdd05e5463fcdc93e0ed2fb54acb15.svg";
export { ForwardRef as ReactComponent };